import { render, staticRenderFns } from "./ConstraintsDetailPage.vue?vue&type=template&id=5de579f6&scoped=true&"
import script from "./ConstraintsDetailPage.vue?vue&type=script&lang=ts&"
export * from "./ConstraintsDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de579f6",
  null
  
)

export default component.exports